<div
  class="change-container"
  [class.new]="change.changeType === BeneficiaryShareChangeTypeEnum.New"
  [class.previous]="
    change.changeType === BeneficiaryShareChangeTypeEnum.Previous ||
    change.changeType === BeneficiaryShareChangeTypeEnum.Removed
  ">
  <span class="name" [class.strikethrough]="change.changeType === BeneficiaryShareChangeTypeEnum.Removed">{{
    change.name
  }}</span>
  <span
    class="share"
    [class.strikethrough]="
      change.changeType === BeneficiaryShareChangeTypeEnum.Previous ||
      change.changeType === BeneficiaryShareChangeTypeEnum.Removed
    ">
    {{ !!change.share ? (change.share | fixedDecimal : 2) : '0.00' }}%
  </span>
</div>
